/*

saikrishna 10/11/2022   2699234404   Fixed Payload in NightJobsTable
Raghu 27/10/2022 3225736869 Table Alignments Fixes and Enhancements
Lalitha 10/27/2022 3225736869 night jobs UX changes
Ashraf 10/30/2022 3225736869 fixed table pagination issue
saikrishna 11/03/2022 3225736869 changed the paginationOptions
Rajesh 11/14/2022 2699234404 Add night jobs New UX.
akhila 11/18/2022 2699234404 added status and createdFro fields
akhila 11/18/2022 2699234404  added execution icon
Rajesh 11/23/2022 2699234404 added delete,copy and execution actions and delete api.
Suresh Peddavoora 11/23/2022 2699234404 Changed Icon style to outlined.
Akhila 11/25/2022 2699234404 Added two columns nextruntime, lastRunTime.
Rajesh 11/28/2022 2699234404 fixed table update  when copy night job
Raghu 11/29/2022 2699234404 Table Footer styling fixes
Poornima 11/30/2022 2699234404 Added redirection after clicking on save in copy popup
rajesh 12/01/2022 2699234404 edit icon job code styling
Lalitha 12/02/2022 2699234404 Added Run icon
Rajesh 12/05/2022 2699234404 fixed deletesuccess toast message
lalitha 12/06/2022 2699234404 removed job name column
Poornima 12/07/2022 2699234404 Changed  Add night jobs
lalitha 12/07/2022 2699234404 added created by payload in search table
Akhila 12/08/2022 2700430604 added session storage for search items
Akhila 12/09/2022 2700430604 fixed session saerch issue
kavya9reddy 12/09/2022 2700430604 Added createdDate in payload
Rohini 12/13/2022 2700430604 Changed copy tooltip name
Lalitha 12/13/2022 2700430604 rename Night Jobs to Scheduler
Akhila 12/15/2022 2700430604 given space in title Created For
Ashraf 12/16/2022 2700430604 fixed role based access
Ashraf 12/18/2022 2700430604 fixed success message issue.
akhila 12/21/2022 2700430604 fixed datetime formate
akhila 12/22/2022 2700430604 changed labels for last & next run time
akhila 12/26/2022 2700430604 fixed startDate and endDate issue
Dilip 12/28/2022 2700430604 added system notes
kavyareddy 12/28/2022 2700430604 Added Download Configuration button and payload
Ashraf 01/05/2023 2700430604 fixed time format issue
lalitha 01/04/2023 2699234404 Disable Scheduler Executions Downloaded Successfully
Ashraf 01/05/2023 2700430604 fixed time format issue
lalitha 01/04/2023 2699234404 Fixed disable issue for Run and History
Akhila 01/24/2023  2699234404 Added "AM" "PM" format in last run and Next run coloum
Dilip 02/09/2023 3225736869 added created for, created by dropdown
Akhila 02/08/2023  2699234404 Added client code column in table
Sohel 02/09/2023 3225736869 payload changes
Dilip 02/10/2023 3225736869 changed column positions
Guru Prasad 02/13/2023 3225736869 Added tooltip for the client code
Sohel 02/16/2023 3225736869 Payload Changes
suresh peddavoora 02/21/2023 3225736869 New UI changes

Akhila 02/27/2023 3225736869 implemented preview file functionality in download configuration
Dilip 02/28/2023 3225736869 Fixed Sorting issue
Akhila 03/10/2023 3225736869 Added preview toast message and loader
Sohel 03/16/2023 3225736869 Fixed Action Props Issue
suresh peddavoora 03/16/2023 3225736869 Toolbar button Alignments
suresh peddavoora 04/03/2023 3225736869 add icon added
Ravi 05/31/2023 3225736869 changed delete popup message
Akhila 06/08/2023 3225736869 created date change to date created field and column
Akhila 06/13/2023 3225736869 Added code and description
*/

import React, {createRef, useState, useEffect, useRef} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination, Button, Tooltip} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationDelete, httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchJobDetails,
  fetchJobExecution,
  ResetMessage as resetMessage,
  fetchRunJobDetails,
  postPrintScheduler,
  resetSchedulerExecutions,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/NightJobs/AddNightJob';
import {useUpdateEffect} from 'react-use';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {makeStyles} from '@material-ui/core';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import DialogBox from '../../../../../components/DialogBox';
import CopyNightJob from './CopyNightJob';
import JobExecution from './JobExecution';
import PageLoader from '../../../../../components/PageLoader';
import moment from 'moment-timezone';
import SchedulerSystemNotes from './SchedulerNote';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import {downloadButton} from '../../../../../util/Content';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import AddIcon from '@material-ui/icons/AddOutlined';
import MaterialTable, {MTableToolbar} from 'material-table';
import reusableInputStyles from '../../../../../components/InputStyles';

export default function RuleGroupSearchTable({
  setTabValue,
  setValue,
  searchData,
  setNightJobCode,
  setIsCopyRowData,
  submit,
  setSubmit,
  setJobCode,
  setSelected,
}) {
  const [runJob, setRunJob] = useState(false);
  const rowDataRef = useRef();
  const queryRef = useRef(null);
  const dispatch = useDispatch();

  const {roleData} = useSelector(({role}) => role);

  const roleAccess = roleData?.window?.['Scheduler']?.SC;

  const useStyles = makeStyles((theme) => ({
    'link': {
      color: '#320469 !important',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();
  const columns = [
    {
      title: 'Job Name',
      field: 'jobCode',
      render: (rowData) => (
        <span
          role="button"
          style={{
            maxWidth: 165,
            textAlign: 'justify',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            borderBottom: '1px solid #000099',
          }}
          className={classes1.link}
          onClick={() => {
            dispatch(fetchJobDetails(rowData?.jobCode));
            setSelected(rowData?.jobCode);
            setTabValue(1);
          }}
        >
          {rowData?.jobCode}
        </span>
      ),
    },
    // {
    //   title: "Job Name",
    //   field: "jobName",
    // },
    {
      title: 'Job Description',
      field: 'jobDescription',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              // textAlign: "justify",
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.jobDescription}
          </div>
        </>
      ),
    },
    {
      title: 'Scheduled Status',
      field: 'jobStatus',
    },
    {
      title: 'Client Code',
      field: 'clientNumber',
      cellStyle: {
        maxWidth: 150,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.clientNumber?.split(',').join(', ')}>
            <span>{rowData?.clientNumber?.split(',').join(', ')}</span>
          </Tooltip>
        );
      },
    },
    {
      title: 'Created For',
      field: 'createdFor',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Draft</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Completed</span>
          </div>
        ),
    },
    {
      title: 'Last Run Date & Time',
      field: 'lastRunTime',
      render: (rowData) => {
        return rowData?.lastRunTime;
        // The date is formatted to UTC on the BE side, so commenting now from the FE side.
        // ? moment(rowData?.lastRunTime).tz("America/New_York").format("MM/DD/YYYY hh:mm:ss A")
        // : "";
      },
    },
    {
      title: 'Next Run Date & Time',
      field: 'nextRunTime',
      render: (rowData) => {
        return rowData?.nextRunTime;
        // The date is formatted to UTC on the BE side, so commenting now from the FE side.
        // ? moment(rowData?.nextRunTime)
        //     .tz("America/New_York")
        //     .utc()
        //     .format("MM/DD/YYYY hh:mm:ss A")
        // : "";
      },
    },
  ];
  const [countTotal, setCountTotal] = useState(null);
  const classes = reusableInputStyles();
  const tableRef = createRef();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [deleteSuccessMsg, setDeleteSuccessMsg] = useState('');
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [copyNightJob, setCopyNightJob] = useState(false);
  const [copyOldJob, setOldcopyOldJob] = useState();
  const [isJobExecution, setJobExecution] = useState(false);
  const [schedulerData, setSchedulerData] = useState();
  const [isNote, setIsNote] = useState(false);
  const [executionRowData, setExecutionRowData] = useState({});

  const {
    jobRunDetailsStatus,
    errorMsg,
    jobDetailsStatus,
    successMsg,
    copyNightJobStatus,
    copyCode,
    isLoading,
    configurationUrl,
    dockey,
  } = useSelector(({addNightJob}) => addNightJob);
  const [status, setStatus] = useState(false);

  const [loading, setIsLoadingDelete] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl || (configurationUrl && !isJobExecution)) {
      setIsLoadingDelete(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingDelete(false);
      }
      readData();
    }
  }, [configurationUrl]);

  useUpdateEffect(() => {
    if (tableRef?.current) {
      tableRef.current.onQueryChange();
    }
  }, [searchData, successMsg]);
  useUpdateEffect(() => {
    if (status) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('scheduler'));
      dispatch(fetchCreatedForDropDownData('scheduler'));
      setStatus(false);
    }
  }, [status]);
  useEffect(() => {
    if (deleteErrorMsg || deleteSuccessMsg) {
      setTimeout(() => {
        setDeleteErrorMsg('');
        setDeleteSuccessMsg('');
      }, 3000);
    }
  }, [deleteErrorMsg, deleteSuccessMsg]);
  useEffect(() => {
    if (jobDetailsStatus === 200 || jobRunDetailsStatus === 200) {
      handleCloseRunDialog();
      setTimeout(() => {
        dispatch(resetMessage());
        setValue(0);
      }, 2000);
    }
  }, [jobDetailsStatus, jobRunDetailsStatus]);
  useEffect(() => {
    if (copyNightJobStatus === 200) {
      setTimeout(() => {
        // dispatch(ResetMessage());
        dispatch(fetchJobDetails(copyCode));
        setTabValue(1);
      }, 2000);
    }
  }, [copyNightJobStatus]);

  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetSchedulerExecutions());
      }, 1500);
    }
  }, [successMsg, errorMsg]);
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const handleCloseRunDialog = () => {
    setRunJob(false);
  };
  const handleRunSubmit = (rowData) => {
    setSubmit(true);
    dispatch(fetchRunJobDetails(rowDataRef?.current?.jobCode));
  };
  const handleSubmit = () => {
    setSubmit(true);
    new Promise((resolve) => {
      httpPaginationDelete(`nightJobs/delete/nightjobs/${deleteData?.jobCode}`)
        .then((response) => {
          if (response?.status === 200 && response?.status !== 400) {
            setDeleteSuccessMsg(response?.message);
            resolve();
            handleCloseDialog();
            setStatus(true);
          }
          if (response?.status === 400) {
            setDeleteErrorMsg(response?.message);
            resolve();
            handleCloseDialog();
          }
          resolve();
        })
        .catch((error) => {
          console.log(error);
        });
    });
  };
  const handleCopyNightJob = () => {
    setCopyNightJob(false);
  };
  const handleJobExecution = () => {
    setJobExecution(false);
  };
  const handleCloseNoteDialog = () => {
    setIsNote(false);
  };
  const handleEdit = (rowData) => {
    dispatch(fetchJobDetails(rowData?.jobCode));
    setSelected(rowData?.jobCode);
    setTabValue(1);
  };
  const handleCopy = (rowData) => {
    setCopyNightJob(true);
    setOldcopyOldJob(rowData);
  };
  const handleRun = (rowData) => {
    rowDataRef.current = rowData;
    setRunJob(true);
  };
  const handleExecution = (rowData) => {
    setJobExecution(true);
    setExecutionRowData(rowData);
    dispatch(fetchJobExecution(rowData?.jobCode));
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setSchedulerData(rowData);
  };
  const searchsessionNightJob = JSON.parse(sessionStorage.getItem('searchNightJob'));
  if (searchsessionNightJob && !submit) {
    searchData = searchsessionNightJob;
  }
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Scheduler'}
      />
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Scheduler"
        value={`Are you sure you want to delete the ${deleteData?.jobCode} Scheduler?`}
        handleSubmit={handleSubmit}
      />
      <DeleteTableRecordPopup
        open={runJob}
        dialogClose={handleCloseRunDialog}
        title="Run Scheduler"
        value={`Are you sure want to run this ${rowDataRef?.current?.jobCode} Scheduler?`}
        handleSubmit={handleRunSubmit}
      />
      <DialogBox
        open={copyNightJob}
        dialogClose={handleCopyNightJob}
        title="Copy Scheduler"
        maxWidth="md"
        hideFooter={true}
      >
        <CopyNightJob copyOldJob={copyOldJob} handleCopyNightJob={handleCopyNightJob} />
      </DialogBox>
      <DialogBox
        open={isJobExecution}
        dialogClose={handleJobExecution}
        title="Scheduler Executions"
        maxWidth="lg"
        hideFooter={true}
      >
        <JobExecution executionRowData={executionRowData} />
      </DialogBox>
      <DialogBox
        open={isNote}
        dialogClose={handleCloseNoteDialog}
        title="Scheduler Notes"
        maxWidth="lg"
      >
        <SchedulerSystemNotes schedulerData={schedulerData} />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-actions-icon new-standard-textfields actions-dropdown-table">
          <MaterialTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `nightJobs/search/all`;
                const bodyObj = {
                  jobCode: searchData?.code ? searchData.code : '',
                  createdFor: searchData?.createdFor?.userLoginName ?
                    searchData?.createdFor?.userLoginName :
                    '',
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                  jobName: searchData?.jobName ? searchData?.jobName : '',
                  jobDescription: searchData?.description ? searchData.description : '',
                  jobStatus: searchData?.status ? searchData?.status : '',
                  nextRuntime: searchData?.nextRunTime ?
                    moment(searchData?.nextRunTime).format('MM/DD/YYYY hh:mm:ss') :
                    '',
                  lastRunTime: searchData?.lastRunTime ?
                    moment(searchData?.lastRunTime).format('MM/DD/YYYY hh:mm:ss') :
                    '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  clientNumber: searchData?.clientCode?.clientNumber ?
                    searchData?.clientCode?.clientNumber :
                    '',
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });

                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setSubmit(false);
                        setCountTotal(response.data.response.count);
                        setArrayLast(data.length === 1);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              // (rowData) => ({
              //   icon: () => <PlayCircleOutlineOutlinedIcon />,
              //   tooltip: rowData?.isDraft !== "Y" ? "Run" : "",
              //   disabled: rowData?.isDraft === "Y" || !roleAccess?.edit,
              //   onClick: (event, rowData) => {
              //     rowDataRef.current = rowData;
              //     setRunJob(true);
              //   },
              // }),
              // {
              //   icon: () => <EditOutlinedIcon />,
              //   tooltip: "Edit",
              //   disabled: !roleAccess?.edit,
              //   onClick: (event, rowData) => {
              //     dispatch(fetchJobDetails(rowData?.jobCode));
              //     setSelected(rowData?.jobCode);
              //     setTabValue(1);
              //   },
              // },
              // {
              //   icon: () => <FileCopyOutlinedIcon className={classes.copyButtonroot} />,
              //   disabled: !roleAccess?.add,
              //   tooltip: "Copy",
              //   onClick: (event, rowData) => {
              //     setCopyNightJob(true);
              //     setOldcopyOldJob(rowData);
              //   },
              // },
              // {
              //   icon: () => <DeleteOutlineOutlinedIcon className={classes.copyButtonroot} />,
              //   disabled: !roleAccess?.delete,
              //   tooltip: "Delete",
              //   onClick: (event, rowData) => handleDelete(rowData),
              // },
              // (rowData) => ({
              //   icon: () => <HistoryIcon />,
              //   // tooltip: "Job Executions",
              //   tooltip: rowData?.isDraft !== "Y" ? "Job Executions" : "",
              //   disabled: rowData?.isDraft === "Y",
              //   onClick: (event, rowData) => {
              //     setJobExecution(true);
              //     dispatch(fetchJobExecution(rowData?.jobCode));
              //   },
              // }),
              // {
              //   icon: () => (
              //     <>
              //       <Button
              //         disabled={!roleAccess?.add}
              //         type="button"
              //         variant="outlined"
              //         className={`search-btn`}
              //       >
              //         Add Scheduler Job
              //       </Button>
              //     </>
              //   ),
              //   disabled: !roleAccess?.add,
              //   isFreeAction: true,
              //   onClick: (event) => {
              //     setTabValue(1);
              //   },
              // },
              // {
              //   icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
              //   tooltip: "Notes",
              //   onClick: (event, rowData) => {
              //     setIsNote(true);
              //     setSchedulerData(rowData?.jobCode);
              //   },
              // },
              {
                icon: () => <SaveIcon />,
                tooltip: 'Save User',
                onClick: (event, rowData) => console.log(rowData, 'rowData'),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn ml-2 ${classes.buttonRoot}`}
                      disabled={Boolean(countTotal === 0)}
                      onClick={() => {
                        dispatch(
                          postPrintScheduler({
                            jobCode: searchData?.code ? searchData.code : '',
                            createdFor: searchData?.createdFor?.userLoginName ?
                              searchData?.createdFor?.userLoginName :
                              '',
                            isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                            jobName: searchData?.jobName ? searchData?.jobName : '',
                            jobDescription: searchData?.description ? searchData.description : '',
                            jobStatus: searchData?.status ? searchData?.status : '',
                            nextRuntime: searchData?.nextRunTime ?
                              moment(searchData?.nextRunTime).format('MM/DD/YYYY hh:mm:ss') :
                              '',
                            lastRunTime: searchData?.lastRunTime ?
                              moment(searchData?.lastRunTime).format('MM/DD/YYYY hh:mm:ss') :
                              '',
                            createdBy: searchData?.createdBy?.userLoginName ?
                              searchData?.createdBy?.userLoginName :
                              '',
                            createdDate: searchData?.createdDate ?
                              moment(searchData?.createdDate).format('MM/DD/YYYY') :
                              '',
                            orderBy:
                              queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                queryRef.current.orderBy.field :
                                '',
                            orderDirection: queryRef.current?.orderDirection ?
                              queryRef.current?.orderDirection :
                              '',
                            limit: '',
                            page: '',
                            clientNumber: searchData?.clientCode?.clientNumber ?
                              searchData?.clientCode?.clientNumber :
                              '',
                          }),
                        );
                      }}
                    >
                      {downloadButton}
                    </Button>
                  </div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleCopy={handleCopy}
                  handleDelete={handleDelete}
                  handleExecution={handleExecution}
                  handleRun={handleRun}
                  hiddenMenu={{
                    edit: false,
                    copy: false,
                    notes: false,
                    hiddenDelete: false,
                    execution: false,
                    run: false,
                    usage: true,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: !roleAccess?.edit,
                    disableCopy: !roleAccess?.add,
                    disableNotes: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableRun: props?.data?.isDraft === 'Y' || !roleAccess?.edit,
                    disableDelete: !roleAccess?.delete,
                    disableExecution: props?.data?.isDraft === 'Y',
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {
                      <Button
                        disabled={!roleAccess?.add}
                        type="button"
                        variant="outlined"
                        className={`search-btn`}
                        isFreeAction={true}
                        onClick={(event) => {
                          setTabValue(1);
                        }}
                        startIcon={<AddIcon />}
                      >
                        Add Scheduler Job
                      </Button>
                    }
                  </div>
                </div>
              ),
            }}
            // onRowClick={(event, rowData) => {
            //   dispatch(fetchNightJob(rowData.id));
            //   dispatch(fetchSchedules(rowData.id));
            //   setNightJobCode(rowData.jobCode);
            //   setSchedule(true);
            //   setValue(1);
            // }}
          />
        </div>
        {isLoading || loading ? <PageLoader /> : ''}
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {(successMsg || deleteSuccessMsg) && (
          <SuccessSnackbar successMsg={successMsg || deleteSuccessMsg} />
        )}
      </Grid>
    </>
  );
}
